import axios from 'axios';
import BaseAPI from './base/base-api';

class LicenseInfoAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'licenseinfo';
}

export default new LicenseInfoAPI();
